import React, { Component, PropsWithChildren } from 'react';
import BlockElement from './BlockElement';
import './BlockUi.scss';
import BlockWindow from './BlockWindow';
import { IBlockUiProps } from './types';

/**
 * Covers element with an overlay with progress indicator to prevent any interactions with that element.
 */
export class BlockUi extends Component<PropsWithChildren<IBlockUiProps>, {}> {
  public render() {
    const Tag = this.props.blockEntireWindow ? BlockWindow : BlockElement;
    const zIndex = this.getZIndex();
    return (
      <Tag blocking={this.props.blocking} zIndex={zIndex}>
        {this.props.children}
      </Tag>
    );
  }

  private getZIndex() {
    if (this.props.determineBestZIndex) {
      const allElements = document.querySelectorAll('*');
      const zIndex =
        Math.max.apply(
          null,
          Array.prototype.map.call(allElements, (el: HTMLElement) => {
            if (el.style && el.style.zIndex) {
              return +el.style.zIndex;
            }
            return 0;
          }),
        ) + 10;
      return zIndex;
    }
    return this.props.zIndex;
  }
}

export default BlockUi;
